import { createContext } from '@lit/context'

export type SchmancyButtonSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg'

export const SchmancyButtonSizeContext = createContext<SchmancyButtonSize>('schmancy-button-size')
